<template>
	<header-block :title="timeOfDay + (customer ? (', ' + customer.person.firstName) : '')"></header-block>
	<CustomerLoadWait :customer="customer && bankInfo" />
	
	<AwaitBankAccountPanel v-if="adding && bankInfo" :origCount="this.bankInfo.accounts.length"
		@accountAdded="adding = false; getBankInfo()" />
	<SwipeCarousel :showArrows="false" :showButtons="true">
		
		<v-carousel-item v-if="pendingShoutMoves && pendingShoutMoves.length > 0">
			<v-row class="carouselPanel">
				<v-col>
					<MovePanel :lite="true" :move="pendingShoutMoves[0].move" :customerMove="pendingShoutMoves[0]"/>
				</v-col>
			</v-row>
		</v-carousel-item>

		<v-carousel-item v-if="bankInfo && bankInfo.accounts.length == 0 && !adding">
			<v-row class="carouselPanel">
				<v-col>
					<LinkAccountsShoutPanel />
				</v-col>
			</v-row>
		</v-carousel-item>

		<v-carousel-item v-if="relinkNeeded">
			<v-row class="carouselPanel">
				<v-col>
					<ReLinkAccountsShoutPanel />
				</v-col>
			</v-row>
		</v-carousel-item>

		<v-carousel-item v-if="showSetupSpendingCycle">
			<v-row class="carouselPanel">
				<v-col>
					<SetPayCycleShoutPanel />
				</v-col>
			</v-row>
		</v-carousel-item>

		<v-carousel-item v-if="showSpendingAnalysis && spendingAnalysisStructured">
			<v-row class="carouselPanel">
				<v-col>
					<AnalysisWidget
						:small="true"
						:chartHeight="120"
						:waitMessage="spendingAnalysisWaitMessage"
						titleLabel="Spending Analysis"
						:spendingAnalysisStructured="spendingAnalysisStructured"
						:selectedSlotKey="selectedSlotKey"
						:formatter="formatter"
						:title="true"
						@click="navigateToSpendingAnalysis()" />
				</v-col>
			</v-row>
		</v-carousel-item>

		<v-carousel-item
			v-if="bankInfo && bankInfo.accounts.length > 0 && bankInfo.recentTransactions && bankInfo.recentTransactions.length > 0">
			<v-row class="carouselPanel">
				<v-col>
					<RecentTransactionsInfoPanel :today="today" :bankInfo="bankInfo" />
				</v-col>
			</v-row>
		</v-carousel-item>
		
		<v-carousel-item v-if="bankInfo && bankInfo.accounts.length > 0">
			<v-row class="carouselPanel">
				<v-col>
					<NewsShoutPanel />
				</v-col>
			</v-row>
		</v-carousel-item>

		<v-carousel-item v-if="bankInfo && bankInfo.accounts.length > 0">
			<v-row class="carouselPanel">
				<v-col>
					<AccountsWidget :max="2"
						:accounts="transactionAccounts.length > 0 ? transactionAccounts : creditCards"
						:formatter="formatter" />
				</v-col>
			</v-row>
		</v-carousel-item>	
	</SwipeCarousel>

	<transition>
		<v-row class="mt-2 mb-2" 
		v-if="
			activeQuestionAnswered !== null &&
			shouldShowQuiz &&
			this.quizPoints && 
			this.quizAnswers !== null"
			>
			<v-col>
				<QuizCard
					:quiz="quizzes[0]"
					:quizPoints="quizPoints"
					:activeQuestionAnswered="activeQuestionAnswered"
					:answers="quizAnswers"
					@rules-click="handleRulesClick"
					@answer-click="handleAnswerClick"
					@show-stats="handleShowStatsClick"
				/>

			</v-col>
		</v-row>
	</transition>

	<transition>
		<div class="wobbleProtector">
			<SmoothScrollContainer v-if="(featuredVouchersReady && recommendedVouchersReady) && marketplace && marketplace.length > 0">
				<ScrollThumbBlock v-if="recommendedVouchers.length > 0" class="smoothScrollPanel"  href="/#/ShopVouchers?recommended=true" title="Discounts for you" subtitle="Based on your spending" :thumbs="recommendedVouchers" :rightimage="require('@/assets/arrow-right.png')">
					<template #footer>
						<SpendingPotButton :amount="savedToSpendBalance" @click="$router.push('/SavedToSpend')" class="spending-pot-footer" />
					</template>
				</ScrollThumbBlock>
				<ScrollThumbBlock v-else class="smoothScrollPanel" href="/#/ShopVouchers?recommended=false" title="Featured Discounts"
					subtitle="Save money every day" :thumbs="featuredVouchers" :rightimage="require('@/assets/arrow-right.png')">
					<template #footer>
						<SpendingPotButton :amount="savedToSpendBalance" @click="$router.push('/SavedToSpend')" class="spending-pot-footer" />
					</template>
				</ScrollThumbBlock>
				<ScrollThumbBlock class="smoothScrollPanel" href="/#/Marketplace" title="Marketplace"
					subtitle="Explorer deals with our partners" :thumbs="marketplace"
					:rightimage="require('@/assets/arrow-right.png')" />
			</SmoothScrollContainer>
		</div>
	</transition>

	<transition>
		<v-row class="financialFitnessRow" v-if="financialFitness && financialFitness.length == 0">
			<v-col>
				<InfoPanel href="/#/FinancialFitness" valueHref="/#/FinancialFitnessHistory"
					:icon="require('@/assets/financialFitnessIcon.png')" title="My Financial Fitness"
					subtitle="Let's calculate your baseline" valueTitle="Score" value="--" />
			</v-col>
		</v-row>
	</transition>

	<transition>
		<div>
		<div v-if="pendingMoves && pendingMoves.length > 0" class="moves-title-row">
			<v-row class="title-row">
				<v-col class="title-col">Moves</v-col>
				<v-col class="right" style="padding-top: 20px;"><a href="/#/Moves">See All</a></v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col class="moves-widget-col">
					<div class="wobbleProtector">
						<MovesWidget v-if="pendingMoves" :moves="pendingMoves" :lite="true" />
					</div>
				</v-col>
			</v-row>
		</div>
		<div v-if="pendingMoves && pendingMoves.length == 0">
			<v-row class="title-row">
				<v-col class="title-col">Moves</v-col>
			</v-row>
			<v-row >
				<v-col>
					<InfoPanel class="shadowed" :icon="require('@/assets/bullet-tick.png')" title="All Moves Completed!" subtitle="You're up to date with all your moves..." />
				</v-col>
			</v-row>
		</div>
	</div>
	</transition>
	
	<!-- Quiz Rules Drawer -->
	<QuizDrawerRulesPanel v-if="this.quizzes && this.quizzes.length > 0"
		ref="quizRulesDrawer"
		:openHeight="'95%'"
		:quiz="quizzes[0]"
		:customer="customer"
		@terms-click="handleTermsClick"
		@notifications-change="handleNotificationsChange"
	/>

	<!-- Quiz Play Drawer -->
	<QuizDrawerPlayPanel v-if="this.quizzes && this.quizzes.length > 0"
		ref="quizPlayDrawer"
		:openHeight="'100%'"
		:quiz="quizzes[0]"
		:customer="customer"
		:originalQuizPoints="quizPoints"
		:answerResponse="answerResponse"
		:openToStats="openToStats"
		@terms-click="handleTermsClick"
		@back-to-home="handleHome()"
		@submit-answer="handleSubmitAnswer(quizzes[0], $event)"
		@drawer-opened="handleQuizDrawerOpened"
		@drawer-closed="handleQuizDrawerClosed"
		@notifications-change="handleNotificationsChange"
	/>

	<!-- Quiz Terms Drawer -->
	<QuizDrawerTermsPanel 
		v-if="this.quizzes && this.quizzes.length > 0"
		ref="quizTermsDrawer" 
		:termsUrl="quizzes[0].termsUrl"
	/>
</template>

<script>
import Services from '../mixins/Services';
import Helpers from '../mixins/Helpers';
import Quiz from '../mixins/Quiz';
import HeaderBlock from './elements/HeaderBlock.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import AwaitBankAccountPanel from './elements/AwaitBankAccountPanel.vue';
import SwipeCarousel from './elements/SwipeCarousel.vue';
import MovePanel from './elements/MovePanel.vue';
import LinkAccountsShoutPanel from './elements/LinkAccountsShoutPanel.vue';
import ReLinkAccountsShoutPanel from './elements/ReLinkAccountsShoutPanel.vue';
import SetPayCycleShoutPanel from './elements/SetPayCycleShoutPanel.vue';
import AnalysisWidget from './elements/AnalysisWidget.vue';
import RecentTransactionsInfoPanel from './elements/RecentTransactionsInfoPanel.vue';
import AccountsWidget from './elements/AccountsWidget.vue';
import NewsShoutPanel from './elements/NewsShoutPanel.vue';
import ScrollThumbBlock from './elements/ScrollThumbBlock.vue';
import SmoothScrollContainer from './elements/SmoothScrollContainer.vue';
import MovesWidget from './elements/MovesWidget.vue';
import InfoPanel from './elements/InfoPanel.vue';
import QuizCard from './elements/QuizCard.vue';
import QuizDrawerRulesPanel from './elements/QuizDrawerRulesPanel.vue';
import QuizDrawerPlayPanel from './elements/QuizDrawerPlayPanel.vue';
import QuizDrawerTermsPanel from './elements/QuizDrawerTermsPanel.vue';
import SpendingPotButton from './elements/SpendingPotButton.vue';

export default {
	mixins: [Services, Helpers, Quiz],
	components: {
		CustomerLoadWait, HeaderBlock 
		, AnalysisWidget
		, AccountsWidget
		, MovesWidget
		, InfoPanel
		, ScrollThumbBlock
		, SmoothScrollContainer
		, AwaitBankAccountPanel 
		, SwipeCarousel
		, RecentTransactionsInfoPanel
		, LinkAccountsShoutPanel
		, ReLinkAccountsShoutPanel
		, SetPayCycleShoutPanel
		, MovePanel
		, NewsShoutPanel
		, QuizCard
		, QuizDrawerRulesPanel
		, QuizDrawerPlayPanel
		, QuizDrawerTermsPanel
		, SpendingPotButton
	},
	data() {
		return {
			selectedTotals: null,
			relinkNeeded: false,
			featuredVouchers: [],
			recommendedVouchers: [],
			featuredVouchersReady: false,
			recommendedVouchersReady: false,
			adding: false,
			spendingAnalysisAttempts: 0,
			spendingAnalysisWaitMessage: null,
			pendingShoutMoves: null,
			discountsStatement: null
		}
	},
	computed: {
		transactionAccounts() {
			var ret = [];
			if (this.bankInfo == null) {
				return ret;
			}
			this.bankInfo.accounts.forEach(a => {
				if (a.accountType.prettyName.toLowerCase() == "current") {
					ret.push(a);
				}
			});
			return ret;
		},
		creditCards() {
			var ret = [];
			if (this.bankInfo == null) {
				return ret;
			}
			this.bankInfo.accounts.forEach(a => {
				if (a.accountType.prettyName.toLowerCase() == "credit") {
					ret.push(a);
				}
			});
			return ret;
		},
		showSpendingAnalysis() {
			return this.bankInfo && this.bankInfo.accounts.length > 0 && this.bankInfo.spendingCycle.id !== "00000000-0000-0000-0000-000000000000";
		},
		showSetupSpendingCycle() {
			return this.bankInfo && this.bankInfo.accounts.length > 0 && this.bankInfo.spendingCycle.id == "00000000-0000-0000-0000-000000000000";
		},
		savedToSpendBalance() {
			return this.discountsStatement?.savedToSpendBalance || 0;
		}
	},
	methods: {
		getBankInfo: function () {
			this._getBankingInfo(() => {
				if (this.bankInfo.accounts.length > 0) {
					this.waitForSpendingAnalysis(() => {
						this.slots = this.spendingAnalysisStructured.slotNames;
						this.selectedSlotKey = this.slots ? this.slots[this.slots.length - 2].key : '';
					});
				}
				this.bankInfo.accounts.forEach(a => {
					if (a.consentExpired) {
						this.relinkNeeded = true;
					}
				});
				if (this.$cookies.get('waitBank')) {
					this.adding = true;
				}
			});
		},

		waitForSpendingAnalysis: function (onSuccess = null) {
			this._getSpendingAnalysisStructured(() => {
				// If they've just linked a bank account, then there will be no spending analysis data yet, so wait up to 6 times.
				if (this.spendingAnalysisStructured.totalIn == 0 && this.spendingAnalysisStructured.totalOut == 0 && this.spendingAnalysisStructured.totalNet == 0 && this.spendingAnalysisAttempts < 6) {
					// Wait for analysis to be ready
					this._clearSpendingAnalysis();
					this.spendingAnalysisWaitMessage = "Crunching the numbers...";
					this.spendingAnalysisAttempts++;
					setTimeout(() => {
						this.waitForSpendingAnalysis(onSuccess);
					}, 5000);
				}
				this._getSpendingPlansFull();
				if (onSuccess) {
					onSuccess();
				}
			});
		},

		onLoad: async function () {
			this._clearExpiredCaches();
			this._getAppConfig();
			this._getCustomer(() => {
				this._getLatestFinancialFitness();
				this._getDiscountsStatement((result) => {
					this.discountsStatement = result;
				});
				this.getBankInfo();
				this._getPendingMoves((moves) => {
					this.pendingShoutMoves = moves.filter(move => move.move.shout == true);
					this.pendingMoves = moves.filter(move => move.move.shout == false);
				}, true);
				this._getProducts(this.customer.employerID);
				this._getAvailableVouchers(() => {
					this.featuredVouchers = [];
					this.availableVouchers.forEach(v => {
						if (v.featured) {
							this.featuredVouchers.push({ img: v.merchant.logoUrl, url: '/#/vouchers/amount/' + v.id });
						}
					});
					this.featuredVouchersReady = true;
					this.featuredVouchers = this.featuredVouchers.sort(() => Math.random() - 0.5);
					this._getRecommendedVouchers(-90, (r) => {
						this.recommended = r;
						this.recommended.forEach(v => {
							this.recommendedVouchers.push({img: v.merchant.logoUrl, url: '/#/vouchers/amount/' + v.id});
						});
						this.recommendedVouchersReady = true;
					});
				});
			this._getProducts();
			this.loadQuizData();
		});
	},	navigateToSpendingAnalysis() {
		this.$router.push('/SpendingAnalysis');
		//this._openV1('/Moves/Spending');
	}

	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.wobbleProtector {
	width: 100vw;
	max-width: 100vw;
	margin-left: -30px;
	padding-left: 30px;
	padding-right: 30px;
	margin-right: -0px;
	overflow-x: hidden;
}

.title-col {
	font-size: 20px;
	padding-bottom: 0px;
}

.moves-title-row {
	.v-col {
		padding-bottom: 5px;

		a {
			text-decoration: underline;
		}
	}
}

.moves-widget-col {
	padding-top: 0px;
	h--eight: 275px;
}

.carouselPanel {
	height: 220px;

	.v-col {
		height: 100% !important;
	}
}

.spending-pot-footer {
	margin: 16px -18px -18px -18px;
	padding: 12px 18px;
	border-top: 1px solid var(--border-color);
	border-radius: 0 0 8px 8px;
	box-shadow: none;
}
</style>
